export enum WatermarkDensity {
  /** 稀疏 */
  sparse = 1,
  /** 标准 */
  standard = 2,
  /** 密集 */
  intensive = 3,
}

export const WatermarkDensityMatrix = {
  /** 稀疏 [行数, 列数] */
  1: [3, 3],
  /** 标准 */
  2: [4, 4],
  /** 密集 */
  3: [5, 5],
}
